import { Injectable } from '@angular/core';
import { SITE_CONFIG } from '@core/configs/themes.config';
import { SubDomain } from '@core/enums/sub-domain.enum';
import { Theme } from '@core/enums/theme.enum';
import { ISiteConfig } from '@core/interfaces/site-config.interface';
import { environment } from '@env';
import { Browser, IPartnerWebConfigTheme, SsrService } from '@interticket/core';
import { MediaService } from '../media/media.service';
import { StoreService } from '../store/store.service';

@Injectable()
export class ConfigService {

  private _siteConfig: ISiteConfig;

  get siteConfig(): ISiteConfig {
    if (!this._siteConfig) {
      this._siteConfig = this.getSiteConfig();
    }
    return this._siteConfig;
  }

  constructor(
    private storeService: StoreService,
    private mediaService: MediaService,
    private ssrService: SsrService
  ) { }

  @Browser()
  private getSubDomain(): SubDomain {
    const host = this.ssrService.window.location.host;

    const domainMatch = Object.values(SubDomain).find(
      (subDomain: SubDomain) => host.includes(subDomain)
    );

    if (domainMatch) {
      return domainMatch;
    }

    return host
      .replace('online-teatr-maly', 'teatr-maly')
      .replace('teatr-maly', 'teatrmaly')
      .split(environment.subDomainSeparator)[0] as SubDomain;
  }

  private getSiteConfig(): ISiteConfig {
    return {
      ...SITE_CONFIG[SubDomain.DEFAULT],
      ...SITE_CONFIG[this.getSubDomain()],
      ...this.mapThemeConfig(),
    };
  }

  private mapThemeConfig(): ISiteConfig {
    const webConfigTheme: IPartnerWebConfigTheme = this.storeService.partnerConfig?.web.theme;

    let siteConfig: ISiteConfig = {
      displayCalendar: this.storeService.partnerConfig?.localization.displayCalendar,
    };

    if (webConfigTheme) {
      siteConfig = {
        ...siteConfig,
        logoSrc: this.mediaService.getImageUrl(webConfigTheme.darkThemeLogoId || webConfigTheme.logoId),
        theme: webConfigTheme.name as Theme,
        showVenueMap: webConfigTheme.showVenueMap,
        termsLink: webConfigTheme.termsLink,
        platformLabel: [this.storeService.partnerConfig?.partnerName, ''],
      };
    }

    return siteConfig;
  }

}
